<template>
  <div id="dashboard-detail">
    <v-container fluid tag="section" class="tabs py-0 pt-1">
      <v-tabs v-model="tab" background-color="transparent" show-arrows height="40">
        <v-tab
          v-for="tab in inputTabs"
          :key="tab"
          :href="`#${tab}`"
          active-class="v-tab-active-class"
        >
          {{ $t(`views.dashboardDetail.tabs.${tab}`) }}
        </v-tab>
      </v-tabs>
    </v-container>

    <v-container fluid tag="section" class="tabs-items pb-10">
      <v-tabs-items v-model="tab" class="transparent-background" touchless>
        <v-tab-item value="yield" :transition="false" :reverse-transition="false">
          <DashboardYield @goTab="goTab" />
        </v-tab-item>
        <v-tab-item value="twr" :transition="false" :reverse-transition="false">
          <DashboardTwr @goTab="goTab" />
        </v-tab-item>
        <v-tab-item value="distribution" :transition="false" :reverse-transition="false">
          <DashboardDistribution />
        </v-tab-item>
        <v-tab-item value="orders" :transition="false" :reverse-transition="false">
          <DashboardOrders />
        </v-tab-item>
        <v-tab-item value="dividends" :transition="false" :reverse-transition="false">
          <DashboardDividends />
        </v-tab-item>
        <v-tab-item value="rewards" :transition="false" :reverse-transition="false">
          <DashboardRewards />
        </v-tab-item>
        <v-tab-item value="commissionsInterests" :transition="false" :reverse-transition="false">
          <DashboardCommissionInterest />
        </v-tab-item>
        <v-tab-item value="depositsWithdrawals" :transition="false" :reverse-transition="false">
          <DashboardDepositWithdrawal />
        </v-tab-item>
        <v-tab-item value="coreOrders" :transition="false" :reverse-transition="false">
          <DashboardCoreOrders />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import gtag from '@/lib/gtag'
import DashboardYield from '@/views/components/dashboardDetail/DashboardYield'
import DashboardTwr from '@/views/components/dashboardDetail/DashboardTwr'
import DashboardDistribution from '@/views/components/dashboardDetail/DashboardDistribution'
import DashboardOrders from '@/views/components/dashboardDetail/orders/DashboardOrders'
import DashboardCommissionInterest from '@/views/components/dashboardDetail/DashboardCommissionInterest'
import DashboardDepositWithdrawal from '@/views/components/dashboardDetail/DashboardDepositWithdrawal'
import DashboardCoreOrders from '@/views/components/dashboardDetail/DashboardCoreOrders'
import DashboardDividends from '@/views/components/dashboardDetail/DashboardDividends'
import DashboardRewards from '@/views/components/dashboardDetail/DashboardRewards'
import visibilityMixin from '@/views/components/core/visibilityMixin'

export default {
  components: {
    DashboardYield,
    DashboardTwr,
    DashboardDistribution,
    DashboardOrders,
    DashboardDividends,
    DashboardRewards,
    DashboardCommissionInterest,
    DashboardDepositWithdrawal,
    DashboardCoreOrders,
  },
  mixins: [visibilityMixin],
  data: () => ({
    tab: null,
    inputTabs: [
      'yield',
      'twr',
      'distribution',
      'orders',
      'dividends',
      'rewards',
      'commissionsInterests',
      'depositsWithdrawals',
      'coreOrders',
    ],
  }),
  watch: {
    tab() {
      gtag.pageview({
        pagePath: `/detail/${this.tab}`,
        pageTitle: `detail|${this.tab}`,
        pageContentGroup: 'page',
      })
    },
  },
  methods: {
    goTab(tab) {
      this.$set(this, 'tab', tab)
      scroll(0, 0)
    },
  },
}
</script>
